import { LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';
import { Condition, Ruleset } from 'lib/rules/types';
import { asyncForEach } from 'lib/utils/async-utils';
import { deepSearch } from 'lib/utils/object-utils';
import { GetStaticPropsContext } from 'next';
import * as plugins from 'temp/rules-conditions-parameters-plugins';

export interface Plugin {
  /**
   * Detect order when the plugin should be called, e.g. 0 - will be called first (can be a plugin which data is required for other plugins)
   */
  conditionId: string;
  /**
   * A function which will be called during personalization parameters generation
   */
  exec(
    condition: Condition,
    context: GetStaticPropsContext,
    layout: LayoutServiceData
  ): Promise<Condition>;
}

export class ConditionParametersFactory {
  /**
   * Update ruleset for given request
   * @param {Ruleset} ruleset
   * @param {GetStaticPropsContext} context
   */
  public async extend(
    rules: string,
    context: GetStaticPropsContext,
    layout: LayoutServiceData
  ): Promise<string> {
    const ruleset = JSON.parse(rules) as Ruleset;

    if (ruleset?.ruleset == undefined || !ruleset?.ruleset[0]?.conditions) {
      return rules;
    }

    const conditions = deepSearch<Condition>(ruleset.ruleset[0].conditions, (x: Condition) => {
      if (x?.type?.toLowerCase() == 'condition') {
        return true;
      }
      return false;
    });

    const parameterPlugins = Object.values(plugins) as Plugin[];

    await asyncForEach(conditions, async (c) => {
      const plugin = parameterPlugins.find((p) => p.conditionId == c.id);
      if (!!plugin) {
        await plugin.exec(c, context, layout);
      }
    });
    return JSON.stringify(ruleset);
  }
}

export const conditionParametersFactory = new ConditionParametersFactory();
